import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';
import Dashboard from './components/screens/Dashboard';
import LoginPopup from './components/LoginPopup';
import VideoPlayback from './components/VideoPlayback';
import { refreshAccessToken } from './api';
import './styles/App.css';
import './styles/LoginPopup.css';
import { apiClient } from './api';

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);

  useEffect(() => {
    const accessToken = Cookies.get('access_token');
    if (accessToken) {
      setIsLoggedIn(true);
    }
  }, []);

  // ...existing interceptor code...

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleVideoClick = (videoId) => {
    setSelectedVideoId(videoId);
  };

  return (
    <Router>
      <div className='App'>
        {!isLoggedIn && <LoginPopup onLogin={handleLogin} />}
        {isLoggedIn && (
          <Routes>
            {/* Dashboard routes */}
            <Route path='/' element={<Navigate to="/dashboard" replace />} />
            <Route path='/dashboard' element={<Dashboard activeScreen="dashboard" />} />
            <Route path='/video' element={<Dashboard activeScreen="video" />} />
            <Route path='/patients' element={<Dashboard activeScreen="participants" />} />
            <Route path='/patient/new' element={<Dashboard activeScreen="patient-form" screenData={{ mode: 'create' }} />} />
            <Route path='/patient/:patientId' element={<Dashboard activeScreen="patient-form" />} />
            
            {/* Doctor routes */}
            <Route path='/doctors' element={<Dashboard activeScreen="doctors" />} />
            <Route path='/doctor/new' element={<Dashboard activeScreen="doctor-form" screenData={{ mode: 'create' }} />} />
            <Route path='/doctor/:doctorId' element={<Dashboard activeScreen="doctor-form" />} />
            
            {/* RA routes */}
            <Route path='/ras' element={<Dashboard activeScreen="ras" />} />
            <Route path='/ra/new' element={<Dashboard activeScreen="ra-form" screenData={{ mode: 'create' }} />} />
            <Route path='/ra/:raId' element={<Dashboard activeScreen="ra-form" />} />
            
            {/* Labeler routes */}
            <Route path='/labelers' element={<Dashboard activeScreen="labelers" />} />
            <Route path='/labeler/new' element={<Dashboard activeScreen="labeler-form" screenData={{ mode: 'create' }} />} />
            <Route path='/labeler/:labelerId' element={<Dashboard activeScreen="labeler-form" />} />
            
            {/* Institution Owner routes */}
            <Route path='/institutionowners' element={<Dashboard activeScreen="institutionowners" />} />
            <Route path='/institutionowner/new' element={<Dashboard activeScreen="institutionowner-form" screenData={{ mode: 'create' }} />} />
            <Route path='/institutionowner/:institutionOwnerId' element={<Dashboard activeScreen="institutionowner-form" />} />
            
            {/* Admin routes */}
            <Route path='/admins' element={<Dashboard activeScreen="admins" />} />
            <Route path='/admin/new' element={<Dashboard activeScreen="admin-form" screenData={{ mode: 'create' }} />} />
            <Route path='/admin/:adminId' element={<Dashboard activeScreen="admin-form" />} />
            
            {/* Info pages routes */}
            <Route path='/disclaimer' element={<Dashboard activeScreen="disclaimer" />} />
            <Route path='/contact' element={<Dashboard activeScreen="contact" />} />
            
            {/* Video playback route */}
            <Route path='/video-playback' element={<VideoPlayback />} />
            
            {/* Catch all - redirect to dashboard */}
            <Route path='*' element={<Navigate to="/dashboard" replace />} />
          </Routes>
        )}
      </div>
    </Router>
  );
};

export default App;